import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-foreground-900 p-8 md:p-14 text-center">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20warm%20amber%20and%20coral%20shapes%20on%20dark%20background%2C%20modern%20minimalist%20design%2C%20flowing%20organic%20lines%2C%20creative%20energy%2C%20digital%20art%20style%2C%20smooth%20gradients%2C%20elegant%20atmosphere&width=1400&height=500&seq=cta-bg-mogutv-2026&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">
              加入{siteInfo.name}，开启创作之旅
            </h2>
            <p className="text-foreground-400 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
              无论你是刚入门的新手还是经验丰富的老手，这里都有适合你的优质资源和创作灵感。立即加入我们，与千万蘑菇tv成品人一起成长。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/latest-recommend"
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                立即探索资源
                <i className="ri-rocket-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-lg backdrop-blur-sm transition-all duration-200 whitespace-nowrap cursor-pointer text-sm border border-background-50/20"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}